import Reveal from "@/components/Reveal";
import { SITE, channels } from "@/mocks/site";

const values = [
  { icon: "ri-spy-line", t: "多源交叉", d: "不轻信单方说法，多个独立信源互相印证才敢标“多方互证”。" },
  { icon: "ri-file-shield-line", t: "可信分级", d: "每条爆料都标注来源与可信等级，把“确定”与“传闻”分得清清楚楚。" },
  { icon: "ri-eye-off-line", t: "克制表述", d: "未官宣即标注“尚未官宣”，不拿推测当事实，不做私人生活猎奇。" },
];

export default function About() {
  return (
    <section id="about" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <Reveal>
          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.24em] text-primary-600">
            <span className="h-px w-8 bg-primary-400"></span> About · 关于我们
          </p>
          <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-900 md:text-[34px]">
            关于瓜田雷达
          </h2>
        </Reveal>

        <div className="mt-8 grid gap-6 lg:grid-cols-12">
          {/* image */}
          <Reveal className="lg:col-span-5" delay={60}>
            <div className="relative h-full min-h-[300px] overflow-hidden rounded-3xl lg:min-h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20community%20editorial%20image%20of%20a%20crowd%20silhouette%20holding%20up%20glowing%20phone%20screens%20and%20small%20paper%20lanterns%20at%20an%20outdoor%20night%20event%20vivid%20red%20and%20amber%20stage%20glow%20behind%20them%20festive%20yet%20elegant%20atmosphere%20soft%20bokeh%20and%20haze%20shallow%20depth%20of%20field%20no%20recognizable%20faces%20magazine%20lifestyle%20aesthetic%20rich%20warm%20tones&width=1000&height=1100&seq=radar-about&orientation=portrait"
                alt="夜幕下举着灯牌的人群剪影，橙红舞台光"
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 to-transparent"></div>
              <div className="absolute bottom-4 left-4 rounded-xl border border-background-50/20 bg-foreground-950/40 px-4 py-3 backdrop-blur">
                <p className="font-heading text-lg font-black text-background-50">
                  “把瓜吃明白，而不是吃晕。”
                </p>
                <p className="mt-1 text-xs text-background-200/85">{SITE.slogan}</p>
              </div>
            </div>
          </Reveal>

          {/* text */}
          <Reveal className="lg:col-span-7" delay={120}>
            <div className="flex h-full flex-col justify-center">
              <h3 className="font-heading text-xl font-black text-foreground-900 md:text-2xl">
                我们是一群把“吃瓜”当成专业活干的圈内情报整理者
              </h3>
              <p className="mt-4 text-[15px] leading-[1.95] text-foreground-700">
                {SITE.intro}
              </p>
              <p className="mt-4 text-[15px] leading-[1.95] text-foreground-700">
                我们不追流量、不抢首发，坚持把每一条未官宣信息按
                <strong className="text-primary-700">行程、资源、戏饼、综艺、代言、空降</strong>
                分门别类整理，并用 4 级可信度标尺帮你筛掉水分。
                对你而言，这里是一份可回溯、能存证的娱乐圈动态“雷达图”。
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-500">
                栏目速览：
                {channels.map((c, i) => (
                  <a key={c.key} href="#latest" className="mx-1 inline-block text-primary-600 hover:text-primary-700">
                    {c.name}
                    {i < channels.length - 1 ? "·" : ""}
                  </a>
                ))}
              </p>
            </div>
          </Reveal>
        </div>

        {/* values */}
        <div className="mt-8 grid gap-4 md:grid-cols-3">
          {values.map((v, i) => (
            <Reveal key={v.t} delay={i * 70}>
              <div className="flex h-full gap-4 rounded-2xl border border-background-200 bg-background-50 p-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                  <i className={`${v.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-900">{v.t}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{v.d}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* disclaimer + contact */}
        <Reveal delay={40}>
          <div className="mt-6 flex flex-col items-start justify-between gap-5 rounded-2xl border border-accent-200/70 bg-gradient-to-r from-accent-100/70 to-background-50 p-6 md:flex-row md:items-center">
            <div className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-500 text-foreground-950">
                <i className="ri-error-warning-line text-xl" aria-hidden="true"></i>
              </span>
              <p className="max-w-2xl text-sm leading-relaxed text-foreground-700">{SITE.coverNote}</p>
            </div>
            <a
              href={`mailto:${SITE.contactEmail}`}
              className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full border border-primary-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-600 hover:text-background-50"
            >
              <i className="ri-mail-open-line text-base" aria-hidden="true"></i>
              联系我们
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}